/**
 * This mapping allow to use different composables for the ConfigureProductModal
 * avoiding to recreate the component for different sections of the site.
 * This object has  the attribute used in ConfigureProductModal.vue component as key, and the composable attribute/method matching it as value for each type like 'landing'.
 * For example, in the rinnovi subscription row section the useRinnovi composable doesn't have setLayoutSelectedPlan, but has setSelectedSubscription
 * so the object will be : 
 * 
       setLayoutSelectedPlan : {
           "landing" : "setLayoutSelectedPlan",
           "rinnovi" : "setSelectedSubscription"
       }
 * 
  If  there is no matching for a field, the default fallback will be landing. If the comopsable hasn't that attribute, undefined will be returned.

 */
export const COMPOSABLE_MAPPING = {
  landing: {
    landing : "landing"
  },
  setLayoutSelectedPlan: {
    landing: "setLayoutSelectedPlan",
    rinnovi : "setSelectedSubscription"
  },
  toggleModule: {
    landing: "toggleModule",
  },
  modulesKeys: {
    landing: "modulesKeys",
  },
  getChoosenModules: {
    landing: "getChoosenModules",
  },
  removeModule: {
    landing: "removeModule",
  },
  setAcceptedQuantities: {
    landing: "setAcceptedQuantities",
  },
  emptyModules: {
    landing: "emptyModules",
  },
  paymentFrequencyChoosen: {
    landing: "paymentFrequencyChoosen",
  },
  mainColor: {
    landing: "mainColor",
  },
  mainTextColor: {
    landing: "mainTextColor",
  },
  showPaymentFrequencySwitcher: {
    landing: "showPaymentFrequencySwitcher",
  },
  selectedPlanLowPaymentFrequency: {
    landing: 'selectedPlanLowPaymentFrequency',
    rinnovi: 'selectedProductLowPaymentFrequency'
  },
  selectedPlanHighPaymentFrequency: {
    landing: 'selectedPlanHighPaymentFrequency',
    rinnovi: 'selectedProductHighPaymentFrequency'
  },
  setPaymentFrequencyChoosen: {
    landing: 'setPaymentFrequencyChoosen'
  },
  plans: {
    landing: 'plans',
    rinnovi: 'subscriptions'
  },
  setPaperAdded: {
    landing: 'setPaperAdded'
  },
  setChoosenShippingMethod: {
    landing: 'setChoosenShippingMethod'
  },
  setSelectedShippingKey: {
    landing: 'setSelectedShippingKey'
  },
  paperAdded: {
    landing: 'paperAdded'
  },
  choosenShippingMethod: {
    landing: 'choosenShippingMethod'
  },
  bundleChoosenConfigurableProducts: {
    landing: 'bundleChoosenConfigurableProducts'
  },
  selectedShippingKey: {
    landing: 'selectedShippingKey'
  },
  userHasSetFrequency: {
    landing: 'userHasSetFrequency'
  },
  setUserHasSetFrequency: {
    landing: 'setUserHasSetFrequency'
  },
  crossSellAdded: {
    landing: 'crossSellAdded'
  },
  setCrossSellAdded: {
    landing: 'setCrossSellAdded'
  },
};
